import Vue from 'vue'
import '../src/plugins/element'
import App from './App.vue'
import store from './store'
import router from './router'
import axios from 'axios'
axios.defaults.baseURL = '//zzdxservice-zzdx-ioqmnvbsfn.cn-beijing.fcapp.run/zzdx'// https已拦截跨源请求：同源策略禁止读取位于
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
Vue.prototype.axios = axios
Vue.config.productionTip = false
Vue.directive('title', {
  inserted: function (el, binding) {
    if (el.dataset.title) {
      document.title = el.dataset.title
    } else {
      document.title = 'loading...'
    }
  }
})
new Vue({
  router: router,
  store: store,
  render: h => h(App)
}).$mount('#app')
